var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForward10Outline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7071 2.29289C14.3166 1.90237 13.6834 1.90237 13.2929 2.29289C12.9024 2.68342 12.9024 3.31658 13.2929 3.70711L14.5929 5.00814C14.403 4.99739 14.1924 5 14 5C11.2389 5 8.73748 6.12038 6.92893 7.92893C5.12038 9.73748 4 12.2389 4 15C4 17.7611 5.12038 20.2625 6.92893 22.0711C8.73748 23.8796 11.2389 25 14 25C16.7611 25 19.2625 23.8796 21.0711 22.0711C22.8796 20.2625 24 17.7611 24 15C24 14.4477 23.5523 14 23 14C22.4477 14 22 14.4477 22 15C22 17.2094 21.1057 19.208 19.6569 20.6569C18.208 22.1057 16.2094 23 14 23C11.7906 23 9.79196 22.1057 8.34315 20.6569C6.89433 19.208 6 17.2094 6 15C6 12.7906 6.89433 10.792 8.34315 9.34315C9.79196 7.89434 11.7906 7 14 7C14.1901 7 14.3785 7.00661 14.565 7.0196L13.2929 8.29289C12.9024 8.68342 12.9024 9.31658 13.2929 9.70711C13.6834 10.0976 14.3166 10.0976 14.7071 9.70711L17.7071 6.70711C18.0976 6.31658 18.0976 5.68342 17.7071 5.29289L14.7071 2.29289Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 12C17.7938 12 19.0037 12.868 19 15.5C18.9963 18.132 17.7938 19 16.25 19C14.7062 19 13.4973 18.132 13.5 15.5C13.5027 12.868 14.7062 12 16.25 12ZM16.25 13.5292C15.4779 13.5292 15.0973 14.0356 15.0973 15.5656C15.0973 17.0956 15.471 17.6019 16.25 17.6019C17.029 17.6019 17.4091 17.0962 17.4091 15.5656C17.4091 14.0349 17.0221 13.5292 16.25 13.5292Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3619 18.5669C10.3619 18.8061 10.5601 19 10.8046 19H11.5573C11.8018 19 12 18.8061 12 18.5669V12.5046C12 12.1946 11.6767 11.985 11.3848 12.1057L9.27027 13.0713C9.10645 13.1391 9 13.2962 9 13.4702V14.0722C9 14.3164 9.25133 14.484 9.48368 14.3947L10.3619 13.973V18.5669Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward10Outline);
export default __webpack_public_path__ + "static/media/forward_10_outline.c532ccb64595e5f7ef15b1c133748f97.svg";
export { ForwardRef as ReactComponent };